export const CROSS_LOCATION = 'location_reporting';
export const OUTREACH_AGG_REPORT = 'report_outreach_aggregate';
export const CREATE_VISIT = 'create_new_visit';
export const CREATE_VISIT_PRE_POST = 'create_visit_prePost';
export const MANAGE_NOTE = 'add_notes';
export const LIST_CONFIG = 'custom_list_config';
export const MANAGE_FILE = 'download_manager';
export const VISIT_HISTORY_REPORT = 'report_custom_guestsVisit2';
